import { stripHtml } from "string-strip-html";

(function ($) {

    'use strict';

    $('[data-toggle="tooltip"]').tooltip();

    function initSlimscrollMenu() {

        $('.slimscroll-menu').slimscroll({
            height: 'auto',
            position: 'right',
            size: "5px",
            color: '#9ea5ab',
            wheelStep: 5,
            touchScrollStep: 50
        });
    }

    function initSlimscroll() {

        $('.slimscroll').slimscroll({
            height: 'auto',
            position: 'right',
            size: "5px",
            color: '#9ea5ab',
            touchScrollStep: 50
        });
    }

    function initMetisMenu() {
        $("#side-menu").metisMenu();
    }

    function initLeftMenuCollapse() {
        $('.button-menu-mobile').on('click', function (event) {
            $("body").toggleClass("enlarged");
        });
    }

    /**
     * Init Large
     */
    function initEnlarge() {
        if ($(window).width() < 1025) {
            $('body').addClass('enlarged');
        } else {
            $('body').removeClass('enlarged');
        }
    }


    $('.TextEditor').trumbowyg({
        tagsToRemove: ['style', 'script', 'img'],
        svgPath: 'https://unpkg.com/trumbowyg@2.9.4/dist/ui/icons.svg',
        autogrow: true,
        removeformatPasted: true,
        btns: [
            ['viewHTML'],
            ['undo', 'redo'],
            ['formatting'],
            ['strong', 'em'],
            ['link'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
            ['unorderedList', 'orderedList'],
            ['horizontalRule'],
            ['removeformat']
        ]
    });


    $('.modal').on('hidden.bs.modal', function () {

        /* Reset Form */
        $(this).find('form').trigger("reset");

        /* Reset Parsley warnings */
        $(this).find('form').parsley().reset();

        /* Reset All selectors */
        $(this).find('.selectized').each(function () {
            $(this)[0].selectize.clear()
        });

        /* Reset Text Editor */
        $(this).find('.TextEditor').trumbowyg('empty');
    });

    /**
     * StickyTabs
     */
    $('.nav-tabs').stickyTabs();

    /**
     * AjaxSetup
     * Author: Patrick Koreneef <patrick@koretech.nl>
     * 2017-2020
     *
     */
    $.ajaxSetup({

        type: 'POST',
        dataType: 'JSON',

        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },

        success: function (data) {

            new Noty({
                type: 'Success',
                entity: data.Entity,
                text: data.Message
            }).show();

            /* Redirect when requested */
            if (data.Redirect) {
                window.location.replace(data.Redirect);
            }

            /* Hide modal */
            $(".modal").modal('hide');

            /* Hide loader */
            $(".Loader").hide();

            /* Reload when requested */
            if (data.Reload) {
                location.reload();
            }

            /* Reload Datatables */
            ReloadDatatables();
        },

        error: function () {
            new Noty({ type: 'Error', entity: 'App', text: 'Operation could not be completed' }).show();
        }
    });

    /**
     * Reload all DataTables
     * Author: Patrick Koreneef <patrick@natpnk.nl>
     *
     */
    window.ReloadDatatables = function () {
        if ($('table').length > 0) {
            $('.table').each(function () {
                var dt = $(this).DataTable();
                dt.draw();
            });
        }
    }

    /**
     * Exists     
     * https://css-tricks.com/snippets/jquery/check-if-element-exists/
     *
     */
    $.fn.exists = function (callback) {
        if (this.length) {
            var args = [].slice.call(arguments, 1);
            callback.call(this, args);
        }
        return this;
    };

    /**
     * Default DataTable Options
     * Default Datables Options for app
     *
     */
    $.extend(true, $.fn.dataTable.defaults, {
        processing: false,
        serverSide: true,
        deferRender: 50,
        pageLength: 50,
        ordering: true,
        deferRender: true,
        responsive: true,
        autoWidth: false,
        paging: true,
        stateSave: false,
        rowId: "ID",
        dom: '<"top"f>rt<"bottom">p<"clear">',
        language: {
            search: "_INPUT_",
            searchPlaceholder: "Zoeken",
            lengthMenu: "Display _MENU_ records per page",
            zeroRecords: "Geen resultaten beschikbaar",
            emptyTable: "Geen gegevens gevonden",
            info: "Pagina _PAGE_ van _PAGES_",
            infoEmpty: "Geen gegevens beschikbaar",
            infoFiltered: "(Gefilterd van _MAX_ totale gegevens)",
            paginate: {
                first: "Eerste",
                last: "Laatste",
                next: "Volgende",
                previous: "Vorige"
            }
        },

        columnDefs: [{
            defaultContent: '',
            targets: "_all"
        }]
    });

    /**
     * Monent locale
     */
    moment.updateLocale('nl');

    /**
     * Default Datepicker options
     *
     */
    $.extend($.fn.datepicker.defaults, {
        autoclose: true,
        language: 'nl',
        format: "DD d MM yyyy",
        startDate: new Date(),
        todayHighlight: true,
    });


    /**
     * MomentJS
     */
    moment.updateLocale(moment.locale(), { invalidDate: "" });

    /**
     * Notifications
     */
    Noty.overrideDefaults({
        'layout': 'topRight',
        'theme': 'metroui',
        'timeout': '3000',
        'progressBar': 'true',
        'animation.open': 'animated fadeInRight',
        'animation.close': 'animated fadeOutRight',

        callbacks: {
            onTemplate: function () {

                /* Success */
                if (this.options.type === 'Success') {

                    this.barDom.innerHTML = '<div class="noty_body">';
                    this.barDom.innerHTML += '<h4 class="entity"><span class="ion-md-checkmark-circle"></span> ' + this.options.entity + '</h4>';
                    this.barDom.innerHTML += '<p class="noty-text">' + this.options.text + '</p>';
                    this.barDom.innerHTML += '<div>';

                }

                /* Info */
                if (this.options.type === 'Info') {

                    this.barDom.innerHTML = '<div class="noty_body">';
                    this.barDom.innerHTML += '<h4 class="entity"><span class="ion-md-information-circle-outline""></span> ' + this.options.entity + '</h4>';
                    this.barDom.innerHTML += '<p class="noty-text">' + this.options.text + '</p>';
                    this.barDom.innerHTML += '<div>';

                }

                /* Warning */
                if (this.options.type === 'Warning') {

                    this.barDom.innerHTML = '<div class="noty_body">';
                    this.barDom.innerHTML += '<h4 class="entity"><span class="ion-md-alert"></span> ' + this.options.entity + '</h4>';
                    this.barDom.innerHTML += '<p class="noty-text">' + this.options.text + '</p>';
                    this.barDom.innerHTML += '<div>';
                }

                /* Error */
                if (this.options.type === 'Error') {

                    this.barDom.innerHTML = '<div class="noty_body">';
                    this.barDom.innerHTML += '<h4 class="entity"><span class="ion-md-nuclear"></span> ' + this.options.entity + '</h4>';
                    this.barDom.innerHTML += '<p class="noty-text">' + this.options.text + '</p>';
                    this.barDom.innerHTML += '<div>';

                }
            }
        }
    })
    
    /**
     * Suprress DataTable Errors
     * Brings no usefull errors when alerting, Instead move them to Console
     *
     */
    $.fn.dataTable.ext.errMode = 'throw';

    $("a[data-toggle=\"tab\"]").on("show.bs.tab", function (e) {
        $($.fn.dataTable.tables(true)).DataTable().columns.adjust().responsive.recalc().draw();
    });

    function init() {
        initSlimscrollMenu();
        initSlimscroll();
        initMetisMenu();
        initLeftMenuCollapse();
        initEnlarge();
    }

    /**
     * Moment
     */
    $.fn.dataTable.render.moment = function (from, to, locale) {

        if (arguments.length === 1) {
            locale = 'en';
            to = from;
            from = 'YYYY-MM-DD';
        }

        else if (arguments.length === 2) {
            locale = 'en';
        }

        return function (d, type, row) {

            if (d) {

                var m = moment(d, from, locale, true);
                return m.format(type === 'sort' || type === 'type' ? 'x' : to);

            } else {

                return null;
            }
        };
    };


    $.fn.dataTable.render.currency = function () {

        var CurrencyFormatter = new Intl.NumberFormat('nl-NL', {
            style: 'currency', currency: 'EUR',
        });

        return function (data) {
            return CurrencyFormatter.format(data);
        }
    };

    $.fn.dataTable.render.actions = function (array) {

        return function (data) {

            var HTML = "";

            array.forEach(function (action) {

                if (action[0].includes('Modal')) {

                    HTML += '<a class="btn btn-' + action[2] + ' btn-sm ' + action[1] + ' m-r-5" data-toggle="modal" data-target="#' + action[0] + '" data-id="' + data.ID + '"></a>';

                } else {

                    HTML += '<a class="btn btn-' + action[2] + ' btn-sm ' + action[1] + ' m-r-5" id="' + action[0] + '" data-id="' + data.ID + '"></a>';
                }
            });

            return HTML;

        };
    };

    $.fn.dataTable.render.html = function () {
        return function (data) {
            return stripHtml(data).result
        }
    };

    $.fn.dataTable.render.ellipsis = function (cutoff, wordbreak, escapeHtml) {
        var esc = function (t) {
            return t
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        };

        return function (d, type, row) {
            // Order, search and type get the original data
            if (type !== 'display') {
                return d;
            }

            if (typeof d !== 'number' && typeof d !== 'string') {
                return d;
            }

            d = d.toString(); // cast numbers

            if (d.length <= cutoff) {
                return d;
            }

            var shortened = d.substr(0, cutoff - 1);

            // Find the last white space character in the string
            if (wordbreak) {
                shortened = shortened.replace(/\s([^\s]*)$/, '');
            }

            // Protect against uncontrolled HTML input
            if (escapeHtml) {
                shortened = esc(shortened);
            }

            return '<span class="ellipsis" title="' + esc(d) + '">' + shortened + '&#8230;</span>';
        };
    };

    init();

})(jQuery)